import { useAuth } from "./AuthProvider";
import {useLocation, Navigate, Outlet} from 'react-router-dom';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return (
      <Navigate to="/admin/administrator" state={{ from: location }} replace />
    );
  }
  return <Outlet />;
};

export const PublicRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is already logged in and trying to access login page, redirect to dashboard
  if (
    user &&
    (location.pathname === "/admin/administrator" ||
      location.pathname === "/admin/register")
  ) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
